const formatEventName = (event: string): string => {
  const mapping: Record<string, string> = {
    dealApprovedEvents: "Trade approved",
    assetsDepositedEvents: "Assets deposited",
    penaltyDepositedEvents: "Penalty deposited",
    dealCreatedEvents: "Trade created",
    dealCancelledEvents: "Trade cancelled",
    dealExpiredEvents: "Trade expired",
    dealRejectedEvents: "Trade rejected",
  };

  return mapping[event] ?? event;
};

export { formatEventName };
